import React, { useState } from 'react';
import { Button } from './ui/button';
import { Menu, X, ArrowRight } from 'lucide-react';

export const NewHeader = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-slate-900/90 backdrop-blur-md border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex-shrink-0">
            <a href="/" className="flex items-center">
              <img 
                src="/narcx_logo_full.png" 
                alt="NarcX+™ Logo" 
                className="h-10 w-auto"
              />
            </a>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <a href="#home" className="text-gray-300 hover:text-white transition-colors duration-200 font-medium">
              Home
            </a>
            <a href="#solution" className="text-gray-300 hover:text-white transition-colors duration-200 font-medium">
              Solution
            </a>
            <a href="#benefits" className="text-gray-300 hover:text-white transition-colors duration-200 font-medium">
              Why NarcX™
            </a>
            <a href="#industries" className="text-gray-300 hover:text-white transition-colors duration-200 font-medium">
              Industries
            </a>
            <a href="#contact" className="text-gray-300 hover:text-white transition-colors duration-200 font-medium">
              Contact
            </a>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:flex">
            <a href="#contact">
              <Button className="bg-gradient-to-r from-blue-600 to-cyan-500 hover:from-blue-700 hover:to-cyan-600 text-white px-6 py-2 rounded-lg transition-all duration-200 hover:scale-105 group">
                Let's Talk
                <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </Button>
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={toggleMenu}
              className="text-gray-300 hover:text-white p-2"
            >
              {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden bg-slate-800/95 backdrop-blur-md rounded-xl mt-2 mb-4 p-4 border border-white/10">
            <nav className="flex flex-col space-y-4">
              <a href="#home" className="text-gray-300 hover:text-white transition-colors duration-200 font-medium" onClick={toggleMenu}>
                Home
              </a>
              <a href="#solution" className="text-gray-300 hover:text-white transition-colors duration-200 font-medium" onClick={toggleMenu}>
                Solution
              </a>
              <a href="#benefits" className="text-gray-300 hover:text-white transition-colors duration-200 font-medium" onClick={toggleMenu}>
                Why NarcX™
              </a>
              <a href="#industries" className="text-gray-300 hover:text-white transition-colors duration-200 font-medium" onClick={toggleMenu}>
                Industries
              </a>
              <a href="#contact" className="text-gray-300 hover:text-white transition-colors duration-200 font-medium" onClick={toggleMenu}>
                Contact
              </a>
              <a href="#contact" className="block w-full" onClick={toggleMenu}>
                <Button className="w-full bg-gradient-to-r from-blue-600 to-cyan-500 hover:from-blue-700 hover:to-cyan-600 text-white px-6 py-2 rounded-lg mt-4">
                  Let's Talk
                </Button>
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};